import { useState } from "react";

const LENGTHS = ["Bouncer", "Short", "Back of Length", "Good", "Full", "Yorker", "Full Toss"];
const LINES = ["Wide Off", "Outside Off", "Stumps", "Outside Leg", "Wide Leg"];
const OUTCOMES = ["dot", "run", "boundary", "wicket"];
const OUT_COLOR = { dot: "#94A3B8", run: "#1E40AF", boundary: "#F59E0B", wicket: "#D90416" };

export function PitchMap({ cells = [], onAdd, readOnly = false }) {
  const [outcome, setOutcome] = useState("dot");

  const counts = {};
  cells.forEach((c) => { const k = `${c.row}-${c.col}`; counts[k] = (counts[k] || 0) + 1; });
  const max = Math.max(1, ...Object.values(counts));

  const cellColor = (row, col) => {
    const k = `${row}-${col}`;
    const n = counts[k] || 0;
    if (!n) return "rgba(255,255,255,0.04)";
    const intensity = 0.25 + (n / max) * 0.6;
    return `rgba(217,4,22,${intensity})`;
  };

  return (
    <div data-testid="pitch-map-grid">
      {!readOnly && (
        <div className="flex gap-2 mb-3 flex-wrap">
          {OUTCOMES.map((o) => (
            <button key={o} onClick={() => setOutcome(o)} data-testid={`pitch-outcome-${o}`}
              className={`px-3 py-1.5 rounded-lg text-xs font-bold capitalize border-2 ${outcome === o ? "text-white border-transparent" : "bg-white border-slate-200"}`}
              style={outcome === o ? { background: OUT_COLOR[o] } : {}}>{o}</button>
          ))}
        </div>
      )}
      <div className="bg-navy rounded-xl p-3 inline-block">
        <div className="flex">
          <div className="flex flex-col justify-around pr-2 text-[9px] text-white/60 font-semibold text-right w-20">
            {LENGTHS.map((l) => <div key={l} className="h-8 flex items-center justify-end">{l}</div>)}
          </div>
          <div>
            <div className="grid" style={{ gridTemplateColumns: `repeat(5, 2.4rem)` }}>
              {LENGTHS.map((_, row) => LINES.map((_, col) => {
                const k = `${row}-${col}`;
                return (
                  <button key={k} disabled={readOnly} data-testid={`pitch-cell-${row}-${col}`}
                    onClick={() => onAdd && onAdd({ row, col, length: LENGTHS[row], line: LINES[col], outcome })}
                    className="h-8 w-[2.4rem] border border-white/10 flex items-center justify-center text-[10px] text-white font-bold"
                    style={{ background: cellColor(row, col) }}>
                    {counts[k] || ""}
                  </button>
                );
              }))}
            </div>
            <div className="grid text-[9px] text-white/60 font-semibold mt-1" style={{ gridTemplateColumns: `repeat(5, 2.4rem)` }}>
              {LINES.map((l) => <div key={l} className="text-center leading-tight">{l.replace("Outside ", "O/").replace("Wide ", "W/")}</div>)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
